import { render } from "./SubscriptionReportPayment.vue?vue&type=template&id=421a4608"
import script from "./SubscriptionReportPayment.vue?vue&type=script&lang=js"
export * from "./SubscriptionReportPayment.vue?vue&type=script&lang=js"
script.render = render

export default script